import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';

function get(name: string) {
  return ContentStorage.get(ComponentKeys.SYOS, name);
}

function getValue(name: string) {
  return ContentStorage.getValue(ComponentKeys.SYOS, name);
}

class SyosPageComponent {
  static get selectedSeatsHeader() {
    return get('SelectedSeatsHeader');
  }

  static get addToCartButton() {
    return get('AddToCartButton');
  }

  static get subtotalLabel() {
    return get('SubtotalLabel');
  }

  static get viewFullMapLink() {
    return get('ViewFullMapLink');
  }

  static get viewEventDetailsButtonLabel() {
    return get('ViewEventDetailsButtonLabel');
  }

  static get backToSeatMapButtonLabel() {
    return get('BackToSeatMapButtonLabel');
  }

  static get cancelButton() {
    return get('CancelButton');
  }

  static get removeButton() {
    return get('RemoveButton');
  }

  static get removeSeatConfirmationMessage() {
    return get('RemoveSeatConfirmationMessage');
  }

  static get labelSeatStatusSelected() {
    return get('LabelSeatStatusSelected');
  }

  static get labelSeatStatusUnavailable() {
    return get('LabelSeatStatusUnavailable');
  }

  static get labelSeatTypeSpecial() {
    return get('LabelSeatTypeSpecial');
  }

  static get labelSeatTypeWheelchair() {
    return get('LabelSeatTypeWheelchair');
  }

  static get legendLabel() {
    return get('LegendLabel');
  }

  static get labelSeatTypeSpecialValue() {
    return getValue('LabelSeatTypeSpecial');
  }

  static get labelSeatTypeWheelchairValue() {
    return getValue('LabelSeatTypeWheelchair');
  }

  static get labelSeatTypeNotForSale() {
    return getValue('LabelSeatTypeNotForSale');
  }

  static get SingleTicketTypesForSeatLabel() {
    return getValue('SingleTicketTypesForSeatLabel');
  }

  static get MultipleTicketTypesForSeatLabel() {
    return getValue('MultipleTicketTypesForSeatLabel');
  }

  static get SelectedSeatsLabel() {
    return getValue('SelectedSeatsLabel');
  }

  static get SelectedSeatsSeparatorText() {
    return getValue('SelectedSeatsSeparatorText');
  }

  static get RemainingSeatsLabel() {
    return getValue('RemainingSeatsLabel');
  }

  static get SelectSeatHeading() {
    return getValue('SelectSeatHeading');
  }

  static get SelectSeatCloseButtonLabel() {
    return getValue('SelectSeatCloseButtonLabel');
  }

  static get TicketTypesForSeatLabel() {
    return getValue('TicketTypesForSeatLabel');
  }

  static get SelectSeatSubmitButtonLabel() {
    return getValue('SelectSeatSubmitButtonLabel');
  }

  static busyIndicatorReservingSeats = 'Reserving seats';

  static busyIndicatorReservationSuccessful = 'Reservation successful';

  static busyIndicatorLoading = 'Loading';

  static busyIndicatorAjaxError = 'An error has occurred';

  static removeSeatConfirmationTitle = 'Remove Seat';

  static maximumSeatsReachedModalTitle = 'Seat Limit Reached';

  static reservationFailureModalTitle = 'Unable to Reserve Seats';

  static ajaxErrorModalTitle = 'An Error Has Occurred';

  static ajaxErrorModalMessage = '<p>Please refresh the page to try selecting seats again.</p><p>You may also click the “Let us choose the best seats for you” link on this page to have the best seats selected for you, or please contact us directly for assistance.</p>';

  static headingAvailableTicketTypes = 'Available ticket types:';

  static headingChooseTicketType = 'Choose a Ticket Type';

  static seatsLoaded = 'Finished Loading.';

  static seatsQuantity = 'Seat Quantity';

  static mapControlsLabel = 'Map Controls';

  static labelEnterFullScreen = 'Enter Full Screen';

  static labelExitFullScreen = 'Exit Full Screen';

  static labelOpenLegend = 'Open Legend';

  static labelSelectASection = 'Select a section';

  static labelAvailableKeyCommands = 'Keyboard Shortcuts';

  static keyCommandsModalDescription = '<p>You can use the following keyboard commands to navigate available seats or to adjust the visible portion of the seat map.</p><p><em><strong>Screen reader users:</strong> To use the map keyboard shortcuts, JAWS users should disable the Virtual PC Cursor (or switch to Forms Mode), and NVDA users should switch to Focus Mode. Alternatively, the map can be navigated with your software\'s virtual cursor, using the Up/Down Arrow keys and heading commands.</em></p>';

  static labelAction = 'Action';

  static labelCommand = 'Command';

  static labelNavigateSeats = 'Navigate Available Seats';

  static labelZoomIn = 'Zoom In';

  static labelZoomOut = 'Zoom Out';

  static labelPanOut = 'Pan Up';

  static labelPanDown = 'Pan Down';

  static labelPanLeft = 'Pan Left';

  static labelPanRight = 'Pan Right';

  static labelResetPanAndZoom = 'Reset Pan and Zoom';

  static labelJumpToFirstSeatInRow = 'Jump to First Seat In Row';

  static labelJumpToLastSeatInRow = 'Jump to Last Seat In Row';

  static labelJumpToFirstRow = 'Jump to First Row';

  static labelJumpToLastRow = 'Jump to Last Row';

  static labelJumpToFirstSeatInSection = 'Jump to First Seat In Section';

  static labelJumpToLastSeatInSection = 'Jump to Last Seat In Section';
}

export default SyosPageComponent;
